export * from './BaseContentSwitcher';
export { default } from './BaseContentSwitcher';
